import { atom } from 'jotai';
import { useAtom } from 'jotai';
import jotaiStore from '../jotai-store.js';
import * as types from './types.js';
const newInteraction = atom({});
export const useNewInteraction = (id) => {
    const [value, set] = useAtom(newInteraction);
    return [
        value[id] ?? types.initialState,
        (key, value) => {
            set((v) => ({
                ...v,
                [id]: { ...(v[id] != null ? v[id] : types.initialState), [key]: value },
            }));
        },
    ];
};
export const resetInteraction = (id, key) => {
    jotaiStore.set(newInteraction, (value) => {
        return {
            ...value,
            [id]: {
                ...(value[id] != null
                    ? { ...value[id], [key]: types.initialState[key] }
                    : types.initialState),
            },
        };
    });
};
export const setInteraction = (id, key, fn) => {
    jotaiStore.set(newInteraction, (value) => {
        return {
            ...value,
            [id]: value[id] != null
                ? { ...value[id], [key]: fn(value[id][key]) }
                : { ...types.initialState, [key]: fn(types.initialState[key]) },
        };
    });
};
//# sourceMappingURL=index.js.map